import React, { useState } from 'react';
import '../App.css';

const Onboarding = ({ user, onComplete }) => {
    const [storeData, setStoreData] = useState({
        storeName: '',
        category: 'clothing',
        description: ''
    });

    const handleComplete = () => {
        if (storeData.storeName) {
            onComplete(storeData);
        }
    };

    return (
        <div className="onboarding-overlay">
            <div className="onboarding-card-wide">


                <div className="onboarding-form-section">
                    <div className="onboarding-step fade-in">
                        <h2>Welcome, {user.given_name}! 👋</h2>
                        <p className="step-subtitle">Let's set up your auto-reply engine. First, name your store.</p>

                        <div className="form-group">
                            <label>What is your Store Name?</label>
                            <input
                                type="text"
                                placeholder="My Awesome Store"
                                value={storeData.storeName}
                                onChange={(e) => setStoreData({ ...storeData, storeName: e.target.value })}
                                autoFocus
                            />
                        </div>

                        <div className="form-group">
                            <label>Category</label>
                            <select
                                value={storeData.category}
                                onChange={(e) => setStoreData({ ...storeData, category: e.target.value })}
                                className="styled-select"
                            >
                                <option value="clothing">Clothing & Apparel</option>
                                <option value="electronics">Electronics</option>
                                <option value="home">Home & Living</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                    </div>

                    <button className="primary-btn full-width-btn" onClick={handleComplete}>
                        Launch Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Onboarding;
